import { memo } from "../../../lib/memo";
import { themeConfig } from "../config";
import { DayCellViewModel } from "../DayCellViewModel";
export var MonthViewModel = /*#__PURE__*/function () {
  var _proto = MonthViewModel.prototype; // FIXME: shouldbe readonly
  // FIXME: shouldbe readonly

  _proto.getHeight = function getHeight(theme) {
    var _themeConfig = themeConfig(theme),
        DAY_SIZE = _themeConfig.DAY_SIZE,
        MONTH_TITLE_OFFSET_HEIGHT = _themeConfig.MONTH_TITLE_OFFSET_HEIGHT,
        MONTH_BOTTOM_MARGIN = _themeConfig.MONTH_BOTTOM_MARGIN;

    return getMonthHeight(this.daysCount, this.offset, DAY_SIZE, MONTH_TITLE_OFFSET_HEIGHT, MONTH_BOTTOM_MARGIN);
  };

  function MonthViewModel(month, year) {
    this.daysCount = void 0;
    this.offset = void 0;
    this.month = void 0;
    this.year = void 0;
    this.days = void 0;
    this.isLastInYear = void 0;
    this.isFirstInYear = void 0;

    if (month < 0) {
      year -= Math.ceil(-month / 12);
      month = 12 + month % 12;
    }

    if (month > 11) {
      year += Math.floor(month / 12);
      month %= 12;
    }

    var daysCount = getMonthsDays(month, year);
    var offset = getMonthOffset(month, year);
    this.daysCount = daysCount;
    this.offset = offset;
    this.month = month;
    this.year = year;
    this.isLastInYear = month === 11;
    this.isFirstInYear = month === 0;
    this.days = Array.from({
      length: daysCount
    }, function (_, i) {
      var isWeekend = (i + getMonthOffset(month, year)) % 7 >= 5;
      return DayCellViewModel.create(i + 1, month, year, isWeekend);
    });
  }

  return MonthViewModel;
}();
MonthViewModel.create = memo(function (month, year) {
  return new MonthViewModel(month, year);
});
var getMonthHeight = memo(function (daysCount, offset, dayHeight, titleHeight, marginBottom) {
  return Math.ceil((daysCount + offset) / 7) * dayHeight + titleHeight + marginBottom;
});
var getMonthsDays = memo(function (month, year) {
  return new Date(year, month + 1, 0).getDate();
});
var getMonthOffset = memo(function (month, year) {
  var day = new Date(year, month, 1).getDay() - 1;

  if (day === -1) {
    return 6;
  }

  return day;
});